export default __webpack_public_path__ + "static/media/books-online.a18ef837.jpg";